export default __webpack_public_path__ + "static/media/Scroll of Snow and Sorrow.8f6e6123.jpg";